<div
    class="tooltip-wrapper"
    [ngStyle]="getWrapperStyles()"
    *ngIf="text">
    <div
        *ngIf="!description"
        class="tooltip-container {{ class }}"
        [ngStyle]="getContainerStyles()"
        [innerHtml]="text"></div>

    <div
        *ngIf="description"
        class="tooltip-container {{ class }}"
        [ngStyle]="getContainerStyles()">
        <div class="tooltip-container-title">{{ text }}</div>
        <div
            class="tooltip-container-description"
            [style.width.px]="hasExplicitWidth ? width : null">
            {{ description }}
        </div>
    </div>
</div>
